import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output} from "@angular/core";
import {OAuthService} from "angular-oauth2-oidc";
import {SsoConfigModel} from "../../../models/sso-config.model";
import {AuthZeroService} from "../../services/auth-zero.service";

@Component({
  standalone: false,
  selector: 'app-sso-logout-button',
  templateUrl: './sso-logout-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SsoLogoutButtonComponent {

  @Input() config: SsoConfigModel;
  @Output() onLogout = new EventEmitter<any>();


  constructor(@Inject(AuthZeroService) private authZeroService: AuthZeroService, @Inject(OAuthService) private oauthService: OAuthService) {

  }

  ngOnInit(): void {

  }

  onClick() {
    this.authZeroService.logout();
    this.onLogout.emit();
  }

}
